import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
  RelationContextType,
  RelationOption,
} from '@components/EntityDrawers/drawers/Relationship/constants/types';
import { edgeDtoToRelationshipFormValues } from '@components/EntityDrawers/drawers/Relationship/edgeDtoToRelationshipFormValues';
import {
  defaultRelationshipTypes,
  defaultValues,
  RelationshipFormValues,
} from '@components/EntityDrawers/drawers/Relationship/form';
import useStore from '@components/MainStage/store';
import { useProject } from '@context/Project';

type Options = {
  form: UseFormReturn<RelationshipFormValues>;
  open: boolean;
  editMode: boolean;
  isLastANDAuto: boolean;
  contextType: RelationContextType | null;
  parentOptions: RelationOption[];
};

const useFormReset = ({
  form,
  open,
  editMode,
  isLastANDAuto,
  contextType,
  parentOptions,
}: Options) => {
  const { clearErrors, reset } = form;

  const {
    toolbox: { mode },
  } = useProject();

  const activeEdge = useStore((s) => s.edges.find((e) => e.selected));

  // Re-sync when server dto changes but edge id stays the same (e.g. shortcut save, drawer stays open).
  useEffect(() => {
    clearErrors();

    if (open && editMode && activeEdge?.data?.dto) {
      setTimeout(
        () =>
          reset({
            ...edgeDtoToRelationshipFormValues(
              activeEdge.data.dto,
              {
                isLastANDAuto,
                contextType,
                parentOptions,
              },
              form.getValues().description,
            ),
            maxWeight: form.getValues().maxWeight,
          }),
        0,
      );

      return;
    }

    reset({
      ...defaultValues,
      type: defaultRelationshipTypes[mode!],
    });
  }, [
    open,
    activeEdge?.id,
    activeEdge?.data?.dto?.updated_at,
    activeEdge?.data?.dto?.reviewed_at,
    editMode,
    isLastANDAuto,
    mode,
    contextType,
    parentOptions,
  ]);
};

export default useFormReset;
